module.exports = __webpack_public_path__ + "media/images/lp/1/support-ashinaga2-pc-d9e300d06144a09a9fdbb19f2e543151.png";